import React from 'react';

type Props = {
  isActive: boolean;
  displayLabel: string;
  total: string;
};
export const CarouselIndex = ({ isActive, displayLabel, total }: Props) => {
  return isActive ? (
    <span className="active">
      <b>{displayLabel}</b> / {total}
    </span>
  ) : (
    <span className="inactive"></span>
  );
};
